import * as React from 'react';
import '../order/OrderDetailsHeader.css';
import State from '../../application/core/State';
import { connect } from 'react-redux';
import EstimationPeriod from '../../domain/EstimationPeriod';
import { Month, monthByNumber } from '../admin/getEstimationMonths';

interface StateProps {
    estimationPeriod: EstimationPeriod;
}

class EstimationsDetailsHeader extends React.PureComponent<StateProps> {
    public render(): JSX.Element {
        return (
            <div className="estimations-details-header">
                <div />
                {this.props.estimationPeriod.months.map((month: Month) => (
                    <div key={month.year + month.month}>
                        <span>{monthByNumber[month.month]}</span>
                    </div>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    estimationPeriod: state.admin.estimationPeriod!
});

export default connect(mapStateToProps)(EstimationsDetailsHeader);



// WEBPACK FOOTER //
// ./src/view/estimations/EstimationsDetailsHeader.tsx